import React,{useState} from 'react'
import {Drawer,Menu,Spin} from "antd"
import {DollarOutlined,
  UsergroupAddOutlined,
  LogoutOutlined,
  UserOutlined

} from '@ant-design/icons'
import firebase from '../../firebase'
import Profile from './Menu/Profile'
import Rewards from './Menu/Rewards'
import Refer from './Menu/Refer'
import Redeem from './Menu/Redeem'
import { useDispatch} from 'react-redux'
const { SubMenu } = Menu;

export default function ProfileDrawer(props) {
   const dispatch = useDispatch();
    const [current,setCurrent] = useState("profile")
    const handleClick=(e)=>{
      setCurrent(e.key)
     
    }
    const logout=()=>{
      firebase.auth().signOut();
      dispatch({type:"AUTH_FAILED"}) 
            dispatch({type:"RESET_USER"}) 
            document.location.href = "/";
  }
  const currentMenu=(m)=>{
    const menu = {
      "profile":<Profile/>,
      "rewards":<Rewards note/>,
      "refer":<Refer/>,
      "redeem":<Redeem/>
    }
    return menu[m];
  }
    return (
        <Drawer
        width={"70%"}
        placement="right"
        closable={true}
        onClose={()=>props.setProfileVisible(false)}
        visible={props.profileVisible}
        >
        
        <Menu onClick={handleClick} selectedKeys={[current]} mode="horizontal">

            <SubMenu  title="Profile" icon={<UsergroupAddOutlined />}>
              <Menu.ItemGroup title="Settings">
                <Menu.Item key="profile" icon={<UserOutlined/>}>Profile</Menu.Item>
                <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={()=>logout()}>Logout</Menu.Item>
              </Menu.ItemGroup>
          </SubMenu>

            <SubMenu  title="Rewards" icon={<DollarOutlined/>}>
              <Menu.Item key="rewards">Coins Balance</Menu.Item>
              <Menu.Item key="redeem">Redeem Coins</Menu.Item>
              <Menu.Item key="refer">Refer and Earn</Menu.Item>
            </SubMenu>
        </Menu>

    

        {currentMenu(current)}


        

      </Drawer>
    )
}
